document.querySelectorAll('.article-body.numbers p:not(.noNumber)').forEach((element, index) => {
    element.setAttribute('id', 'avsnitt-'+index);
});